import { Pager as HeadlessPager } from '@coveo/headless';
import React from 'react';
import { useEffect, useState, FunctionComponent } from 'react';
import classNames from 'classnames';

interface PagerProps {
	className?: string;
	mode?: string;
	controller: HeadlessPager;
	attributes: {
		firsttext?: string;
		lasttext?: string;
		prevtext?: string;
		nexttext?: string;
	};
	moreText?: string;
	onChange?: ( page: number ) => void;
}

export const Pager: FunctionComponent<PagerProps> = ( {
	className = null,
	moreText = 'Load More',
	mode = null,
	controller,
	attributes = {
		firsttext: 'First',
		lasttext: 'Last',
		prevtext: '<',
		nexttext: '>',
	},
	onChange = () => {},
} ) => {
	const [ state, setState ] = useState( controller.state );

	useEffect( () => {
		controller.subscribe( () => setState( controller.state ) );
	}, [] );

	useEffect( () => {
		onChange( state.currentPage );
	}, [ state?.currentPage ] )

	return (
		<div className={ classNames( 'coveo-advanced-query__pagination', className ) }>
			{ 'more' === mode ? (
				<button className="coveo-advanced-query__pagination-more" onClick={ () => controller.fetchMoreResults() }>
					{ moreText }
				</button>
			) : (
				<nav className="pagination">
					<ul className="pagination__items">
						{/* <li className="pagination__item pagination__item--first">
							<button className={ 'pagination__link' } onClick={ () => controller.selectPage( 1 ) }>
								{ attributes.firsttext ? attributes.firsttext : 'First' }
							</button>
						</li> */}
						<li className="pagination__item pagination__item--previous">
							<button className="pagination__link" disabled={ ! state.hasPreviousPage } onClick={ () => controller.previousPage() }>
								<svg
									className="svg svg--svg-assets-svg-icon-search"
									role="img"
									focusable="false"
									height="24"
									width="24"
									aria-labelledby="svg-assets-svg-icon-arrow-right-wide-title"
									style={ { transform: `rotate(180deg)` } }
								>
									<title id="svg-assets-svg-icon-arrow-right-wide">{ attributes.nexttext ? attributes.nexttext : '>' }</title>
									<use xlinkHref="#svg-assets-svg-icon-arrow-right-wide"></use>
								</svg>
								<span className="pagination__link-text">
									{ attributes.prevtext ? attributes.prevtext : '<' }
								</span>
							</button>
						</li>
						<li className="pagination__item pagination__item--numbers">
							<ul className="pagination__numbers">
								{ state.currentPages.map( ( page ) => (
									<li className="pagination__number" key={ page }>
										<button
											className={ 'pagination__link' + ( controller.isCurrentPage( page ) ? ' pagination__link--disabled' : '' ) }
											key={ page }
											disabled={ controller.isCurrentPage( page ) }
											onClick={ () => controller.selectPage( page ) }
										>
											{ page }
										</button>
									</li>
								) ) }
							</ul>
						</li>
						<li className="pagination__item pagination__item--previous">
							<button className="pagination__link" disabled={ ! state.hasNextPage } onClick={ () => controller.nextPage() }>
								<span className="pagination__link-text">
									{ attributes.nexttext ? attributes.nexttext : '>' }
								</span>
								<svg
									className="svg svg--svg-assets-svg-icon-search"
									role="img"
									focusable="false"
									height="24"
									width="24"
									aria-labelledby="svg-assets-svg-icon-arrow-right-wide-title"
								>
									<title id="svg-assets-svg-icon-arrow-right-wide">{ attributes.nexttext ? attributes.nexttext : '>' }</title>
									<use xlinkHref="#svg-assets-svg-icon-arrow-right-wide"></use>
								</svg>
							</button>
						</li>
						{/* <li className="pagination__item pagination__item--last">
							<button className={ 'pagination__link' } onClick={ () => controller.selectPage( state.maxPage ) }>
								{ attributes.lasttext ? attributes.lasttext : 'Last' }
							</button>
						</li> */}
					</ul>
				</nav>
			) }
		</div>
	);
};
